import { render, staticRenderFns } from "./import2.vue?vue&type=template&id=771b9e18&scoped=true&"
import script from "./import2.vue?vue&type=script&lang=js&"
export * from "./import2.vue?vue&type=script&lang=js&"
import style0 from "./import2.vue?vue&type=style&index=0&id=771b9e18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b9e18",
  null
  
)

export default component.exports